export default __webpack_public_path__ + "static/bathroom@1x-a68afa9c64e6642629150436d8ba9d3e.webp";